function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function GetDateDifference(dateOne, dateTwo) {
  var currentDate = dateTwo || new Date();
  var elapsed = currentDate.getTime() - dateOne.getTime();
  elapsed = elapsed / 1000 / 60; // Time in minutes

  return elapsed < 0 ? -Math.floor(-elapsed) : Math.floor(elapsed);
}

function GetDateDifferenceSeconds(dateOne, dateTwo) {
  var currentDate = dateTwo || new Date();
  var elapsed = currentDate.getTime() - dateOne.getTime();
  elapsed = elapsed / 1000; // Time in seconds

  return elapsed < 0 ? -Math.floor(-elapsed) : Math.floor(elapsed);
}

;

function AddTrailingZero(number) {
  return number < 10 ? "0" + number : number;
}

function GetMonth(monthIndex) {
  var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  return months[monthIndex];
}

function ShowForm() {
  var formId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "cd_data-container";
  var loaderId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "cd_data-loader";
  var loader = document.getElementById(loaderId);
  var formsContainer = document.getElementById(formId);
  loader.style.display = "none";
  formsContainer.style.display = "block";
}

function ShowFormUsingVisibility() {
  var formId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "cd_data-container";
  var loaderId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "cd_data-loader";
  var loader = document.getElementById(loaderId);
  var formsContainer = document.getElementById(formId);
  loader.style.display = "none";
  formsContainer.style.visibility = "initial";
}

function ShowLoader() {
  var formId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "cd_data-container";
  var loaderId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "cd_data-loader";
  var loader = document.getElementById(loaderId);
  var formsContainer = document.getElementById(formId);
  loader.style.display = "block";
  formsContainer.style.display = "none";
}

function ShowLoaderUsingVisibility() {
  var formId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "cd_data-container";
  var loaderId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "cd_data-loader";
  var loader = document.getElementById(loaderId);
  var formsContainer = document.getElementById(formId);
  loader.style.display = "block";
  formsContainer.style.visibility = "hidden";
}

function ShowErrorMessage(msg) {
  var formId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "cd_data-container";
  var loaderId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "cd_data-loader";
  var errorId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "cd_error-resp";
  var loader = document.getElementById(loaderId);
  var formsContainer = document.getElementById(formId);
  var respErrorContainer = document.getElementById(errorId);
  loader.style.display = "none";
  formsContainer.style.display = "none";
  respErrorContainer.style.display = "block";
  respErrorContainer.innerHTML = msg;
}

function HideErrorMessage() {
  var formId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "cd_data-container";
  var errorId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "cd_error-resp";
  var formsContainer = document.getElementById(formId);
  var respErrorContainer = document.getElementById(errorId);
  formsContainer.style.display = "block";
  respErrorContainer.style.display = "none";
  respErrorContainer.innerHTML = "";
}

function ShowInlineErrorMessage(msg) {
  var formId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "cd_data-container";
  var loaderId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "cd_data-loader";
  var errorId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "cd_error-resp";
  var loader = document.getElementById(loaderId);
  var formsContainer = document.getElementById(formId);
  var respErrorContainer = document.getElementById(errorId);
  loader.style.display = "none";
  formsContainer.style.display = "block";
  respErrorContainer.style.display = "block";
  respErrorContainer.innerHTML = msg;
}

function SortAppointments(appointments) {
  var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "asc";
  return appointments.sort(function (a, b) {
    return IsDateAfter(new Date(a.appointment_start), new Date(b.appointment_start)) ? -1 : 1;
  });
}

;

function IsDateAfter(dateOne, dateTwo) {
  return GetDateDifference(dateOne, dateTwo) > 0;
}

;

function GetDateDifference(dateOne, dateTwo) {
  var currentDate = dateTwo || new Date();
  var elapsed = currentDate.getTime() - dateOne.getTime();
  elapsed = elapsed / 1000 / 60; // Time in minutes

  return elapsed < 0 ? -Math.floor(-elapsed) : Math.floor(elapsed);
}

;

function getFrameByEvent(event) {
  return [].slice.call(document.getElementsByTagName('iframe')).filter(function (iframe) {
    return iframe.contentWindow === event.source;
  })[0];
}

function hideAllExcept(exceptId, iframeIds) {
  var _iterator = _createForOfIteratorHelper(iframeIds),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var iframe = _step.value;

      if (iframe != exceptId) {
        var iframeElem = document.getElementById(iframe);
        iframeElem.style.display = "none";
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

function showAllElemsIn(iframeIds) {
  var _iterator2 = _createForOfIteratorHelper(iframeIds),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var iframe = _step2.value;
      var iframeElem = document.getElementById(iframe);
      iframeElem.style.display = "block";
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
}

/** Convert date string to standard australian format DD/MM/YYYY */
function FormatDate(dateString) {
  if (dateString.toUpperCase() == "N/A") return "N/A";

  var date = new Date(dateString);

  if (date != "Invalid Date") {
    var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
    var year = date.getFullYear();
    return day + "/" + month + "/" + year;
  }

  return dateString;
}

function GetURLParams() {
  var vars = {};
  var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
    vars[key] = value;
  });
  return vars;
}

function ExtractCustomerIdFromURL() {
  var path = window.location.pathname;

  if (path && path != "" && path.indexOf("/") > -1) {
    var segs = path.split("/"); // This is a double check, you could probably get away with just returning 3rd item. Or do regex check on each item.

    if (segs[1].toLowerCase() == "account" && segs[2].toLowerCase() == "activate") {
      return segs[3];
    }
  }

  return undefined;
}

function formatAsMoney(value) {
  if (isNaN(value)) return value.toString();
  // USD is set here because setting AUD adds a 'A' prefix to the response
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  });
  return formatter.format(value);
}
function formatAsShortMonthName(date) {
  if (!date) return "";
  var formatter = new Intl.DateTimeFormat('en-AU', {
    month: 'short'
  });
  return formatter.format(date);
}
/** Format date object to string with format DD/MM/YYYY HH:mm am/pm */
function formatAsDateTime(date) {
  if (!date) return "";
  var formatter = new Intl.DateTimeFormat('en-AU', {
    day: "numeric",
    month: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "numeric"
  });
  return formatter.format(date);
}
function SortDateStrings(objArray, dateKey) {
    return objArray.sort((a, b) => (new Date(b[dateKey]).getTime() - new Date(a[dateKey]).getTime()));
};